import React from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import Icon from "../icon/Icon";
import "./AppTable.css";

/// Row "more" menu for tables.
///
/// actions: [{ label, icon?, onClick, danger?, disabled?, loading?, hidden? }]
/// Danger actions (e.g. Delete) are grouped at the bottom after a divider.
/// Clicks never bubble to the row, so it is safe inside a clickable row.
const TableActions = ({ actions }) => {
  const visible = (actions ?? []).filter((a) => a && !a.hidden);
  if (visible.length === 0) return null;
  const normal = visible.filter((a) => !a.danger);
  const danger = visible.filter((a) => a.danger);

  const renderItem = (action) => (
    <li key={action.label}>
      <DropdownItem
        tag="a"
        href="#action"
        disabled={action.disabled || action.loading}
        className={action.danger ? "app-table-actions__item--danger" : ""}
        onClick={(ev) => {
          ev.preventDefault();
          action.onClick?.();
        }}
      >
        {action.icon && <Icon name={action.icon}></Icon>}
        <span>{action.label}</span>
        {action.loading && <Spinner size="sm" className="ms-auto" />}
      </DropdownItem>
    </li>
  );

  return (
    <div className="app-table-actions" onClick={(e) => e.stopPropagation()}>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          type="button"
          className="app-table-actions__toggle"
          aria-label="Actions"
        >
          <Icon name="more-h"></Icon>
        </DropdownToggle>
        <DropdownMenu end className="app-table-actions__menu">
          <ul className="link-list-opt no-bdr">
            {normal.map(renderItem)}
            {normal.length > 0 && danger.length > 0 && (
              <li className="divider"></li>
            )}
            {danger.map(renderItem)}
          </ul>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default TableActions;
